<template>
  <div>
    <v-menu
      bottom
      left
      min-width="100"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          x-small
          icon
          outlined
          color="primary"
          v-bind="attrs"
          v-on="on"
        >
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>

      <v-list
        dense
        class="pa-0"
      >
        <v-list-item
          :disabled="!$store.getters.checkUserPrivilege('INVENTORY')"
          @click="$emit('edit', tenant)"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-circle-edit-outline
            </v-icon>
            Edit
          </v-list-item-title>
        </v-list-item>
        <v-divider />
        <v-list-item
          v-if="tenant.activeStatus"
          :disabled="!$store.getters.checkUserPrivilege('INVENTORY')"
          @click="inActivate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="error"
            >
              mdi-lightbulb-off
            </v-icon>
            In-activate
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-else
          :disabled="!$store.getters.checkUserPrivilege('INVENTORY')"
          @click="activate()"
        >
          <v-list-item-title>
            <v-icon
              small
              left
              color="success"
            >
              mdi-lightbulb-on
            </v-icon>
            Activate
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { failure } from "@/mixins/common";

export default {
  name: "TenantOptions",
  components: {},
  mixins: [failure],
  props: {
    tenant: {
      type: Object,
      required: true
    }
    // active: {
    //   type: Boolean,
    //   required: true 
    // }
  },
  data() {
    return {
      editAlert: false
    };
  },
  methods: {
    inActivate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to inactivate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(
              `${this.ADMIN_API_URL}/inventory/tenants/${this.tenant.id}/inactivate`
            )
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    activate() {
      this.$root.$confirm
        .open("Confirm", "Are you sure you want to activate?", {})
        .then((confirm) => {
          if (!confirm) {
            return;
          }
          this.$http
            .put(
              `${this.ADMIN_API_URL}/inventory/tenants/${this.tenant.id}/activate`
            )
            .then(
              (data) => {
                this.handleSuccess(data.body);
              },
              (failure) => {
                this.handleFailure(failure);
              }
            );
        });
    },
    handleSuccess(response) {
      this.$store.commit("showSnackbar", {
        timeout: 3000,
        message: response.message
      });
      this.$emit("reload");
    },
    fetchNotification() {
      this.editAlert = true;
    }
  }
};
</script>
